import React, { useState } from 'react'
import { Dropdown } from 'antd'
import { CaretDown, Export, EnvelopeSimple, Bell, Ticket } from '@phosphor-icons/react'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import { leagueEventStore } from 'state/league/leagueEvent'
import { eventShatStore } from 'state/event/eventChat'
import { useGetLeagueAttendeesExport } from 'api/league/LeagueAttendance/leagueAttendance'
import ExportLeagueAttendeesModal from './ExportLeagueAttendeesModal'
import type { MenuProps } from 'antd'

const ManageAttendeesModal: React.FC = () => {
  const [exportOpen, setExportOpen] = useState(false)

  const { setTicketsModalOpen } = leagueAttendanceStore(store => ({
    setTicketsModalOpen: store.setTicketsModalOpen,
  }))

  const { setChatModalVisible, setSelectedParticipants } = eventShatStore(store => ({
    setChatModalVisible: store.setChatModalVisible,
    setSelectedParticipants: store.setSelectedParticipants,
  }))

  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))
  const leagueId: string = (leagueData as any)?._id || ''

  const { data: exportData = [], isFetching: exportLoading, refetch: fetchExport } = useGetLeagueAttendeesExport(leagueId)

  const handleOpenExport = () => {
    fetchExport()
    setExportOpen(true)
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'export',
      label: (
        <div className="flex align-center gap-10px">
          <Export size={16} color="#000" />
          <span>Export attendees</span>
        </div>
      ),
      onClick: handleOpenExport,
    },
    {
      key: 'contact',
      label: (
        <div className="flex align-center gap-10px">
          <EnvelopeSimple size={16} color="#000" />
          <span>Contact parents</span>
        </div>
      ),
      onClick: () => {
        setSelectedParticipants([])
        setChatModalVisible(true)
      },
    },
    {
      key: 'tickets',
      label: (
        <div className="flex align-center gap-10px">
          <Ticket size={16} color="#000" />
          <span>Tickets</span>
        </div>
      ),
      onClick: () => setTicketsModalOpen(true),
    },
  ]

  return (
    <>
      <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
        <button className="att-manage-attendees-btn">
          Manage attendees <CaretDown size={14} color="#2ba7ca" />
        </button>
      </Dropdown>

      {exportOpen && (
        <ExportLeagueAttendeesModal
          open={exportOpen}
          onClose={() => setExportOpen(false)}
          data={exportData}
          loading={exportLoading}
        />
      )}
    </>
  )
}

export default ManageAttendeesModal
